import { useCallback, useContext, useState } from 'react';
import { DataRoomShareableLink } from 'models/ShareableLink';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';

export type UseShareableLinkActionProps = {
  link: DataRoomShareableLink;
  updateShareableLink?: (link: DataRoomShareableLink) => void;
  onAfterToggleState?: (linkBeforeToggle: DataRoomShareableLink) => void;
};

const useChangeShareableLinkState = (props: UseShareableLinkActionProps) => {
  const { link, updateShareableLink, onAfterToggleState } = props;

  const { _id, isActive } = link;

  const [isLoading, setIsLoading] = useState(false);

  const { doesntHaveAccess } = useContext(DataRoomContext);
  const { popServerError } = useContext(PopNotificationsContext);

  const changeState = useCallback(async () => {
    if (doesntHaveAccess) return;

    try {
      setIsLoading(true);

      const { data } =
        await dataRoomApi.shareableLinks.changeShareableLinkState(
          _id,
          !isActive,
        );

      updateShareableLink?.({ ...link, ...data });
      onAfterToggleState?.(link);
    } catch (e) {
      popServerError(e);
    } finally {
      setIsLoading(false);
    }
  }, [
    doesntHaveAccess,
    _id,
    isActive,
    updateShareableLink,
    onAfterToggleState,
    link,
    popServerError,
  ]);

  return {
    changeState,
    isActive,
    isChangeStateLoading: isLoading,
    isChangeStateDisabled: isLoading || doesntHaveAccess,
  };
};

export default useChangeShareableLinkState;
